module.exports = __webpack_public_path__ + "static/media/profile-icon.48245c31.svg";